import { IconButton } from "@mui/material";
import React from "react";

const MuiIconButton = ({ children, ...rest }) => {
  return <IconButton {...rest}>{children}</IconButton>;
};

export default MuiIconButton;
